<template>
  <v-dialog v-model="dialog" persistent max-width="750px">
  <v-card>
    <ModelTitle title="New Application" @close="close()" />
    <NewApplication :currentBusiness="Business" :takeCard="false"/>
  </v-card>
    
  </v-dialog>
</template>

<script>
import NewApplication from "@/modules/Application/components/NewApplication.vue"
import { mapGetters } from 'vuex';
import applicationService from "@/modules/Application/service.js";

export default {
  props: ['createDialog'],
  name: "create-Lead",
  data() {
    return {
      dialog: false,
      Business: null
    };
  },
  components: {
    NewApplication
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"])
  },
  watch: {
    createDialog(val) {
      console.log('open', val)
      this.dialog = val;
      if (val) {
        this.loadBusiness()
      }
    },
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.id;
      console.log("id", id);
      applicationService
        .getBusinessInformation({ key: this.currentBusiness.code })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          // this.StripeKey = this.Business.metadata.publicStripeId;
          this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
